import initSliders from "../components/initSliders.js";

document.addEventListener("DOMContentLoaded", () => {

    const {
        initAchievementsSlider
    } = initSliders();

    initAchievementsSlider();

});
